const CLOUD_VPS_TYPES: readonly string[] = [
	'Cloud.VPS',
	'Cloud.VPS.WIN',
	'Cloud.VPS.CCC',
	'Cloud.VPS.WIN.CCC',
];

/**
 * Whether the asset is a Cloud VPS server, going by its product code (the
 * asset's `type`). Matching is case-sensitive.
 *
 * Mirrors the `Cloud.VPS*` codes in banana-stand's `getIsVps`
 * (`@liquidweb-dev/banana-stand/parsers`). That helper also matches the legacy
 * `SS.VPS*` codes and the StellarWP variant, which are deliberately left out:
 * Cloud VPS here means the `Cloud.VPS*` codes only.
 */
const isCloudVps = (type?: string | null) =>
	CLOUD_VPS_TYPES.includes(type ?? '');

export default isCloudVps;
